import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpCssClient } from '../shared/http-request.interceptor'
import { CitySettings } from '../settings/city.settings';
import { City } from '../models/city.model';
import { AboutCity } from '../models/about-city.model';
import { UsefulInformation } from '../models/useful-information.model';


@Injectable()
export class CityService{

    constructor(private http: HttpCssClient){};

    getCity(id): Observable<City> {
        let uri = CitySettings.CITY_DETAILS;
        uri = uri.replace(':id',id);
        return this.http.get(uri).pipe(map(response => {
            let body = response;
            return body;
        }));
    }

    getAboutCity(id): Observable<AboutCity[]>{
        let uri = CitySettings.CITY_ABOUT;
        uri = uri.replace(':id',id);
        return this.http.get(uri)
        .pipe(map(response => {
            let body = response;
            return body;
        }));
    }

    getUsefulInformation(id): Observable<UsefulInformation[]>{
        let uri = CitySettings.CITY_USEFUL;
        uri = uri.replace(':id',id);
        return this.http.get(uri)
        .pipe(map(response => {
            let body = response;
            return body;
        }));
    }

    getCityHrefs(id): Observable<any>{        
        let uri = CitySettings.CITY_HREFS;
        uri = uri.replace(':id',id);
        return this.http.get(uri)
        .pipe(map(function(response: Response){
            //TODO: Add english when it is available.
            // @ts-ignore
            let body = response.filter( elem => elem.locale === "es_ES" || elem.locale === 'en_GB' );
            return body;
        }));
    }
}